<template>
  <div>
    <div>
      <div class="sixteentosix sixteentosix-wrap omt-6 omt-md-25">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/worldmap-2.jpg');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/default_header.png" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5" v-if="editMode">
                {{ $t("edit_training_event_category") }}
              </div>
              <div class="text-subtitle-2 text-md-h5" v-else>
                {{ $t("create_training_event_category") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" editName="create_training_event_category" />
    <Breadcrumb
      v-else
      editName="edit_training_event_category"
      :trainingNameEdit="categoryNameBreadCrumb"
    />

    <div>
      <div class="pt-8">
        <div class="row disablerow justify-content-between align-items-start">
          <!-- Tabs -->
          <v-tabs
            v-model="languageTab"
            align-with-title
            touchless
            scrollable
            show-arrows
            class="LanguageselectTabgroup pt-md-4 pt-lg-0 pl-md-8 pl-4"
          >
            <v-tabs-slider color="indigo"></v-tabs-slider>

            <v-tab
              v-for="(language, i) in languageTabsNew"
              :key="language + i"
              class="LanguageselectTab"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    style="display: flex; align-items: center"
                  >
                    <img
                      style="width: 26px; height: 17px; vertical-align: unset"
                      :src="'/files/flags/' + language.flag"
                    />
                    &nbsp;&nbsp;
                    <span class="langauge-text-slider">
                      {{
                        language.shortForm === "KK"
                          ? "KZ"
                          : language.shortForm === "ZH" ||
                            language.shortForm === "CN"
                          ? "CN"
                          : $t(language.shortForm)
                      }}
                    </span>
                  </div>
                </template>
                <span>{{ $t(language.language) }}</span>
              </v-tooltip>
            </v-tab>
          </v-tabs>
          <div class="col-xl-9 px-8 pr-md-10 pr-lg-0 innercreatetraining">
            <!-- Put Content here -->
            <v-tabs-items v-model="languageTab" touchless>
              <v-tab-item
                v-for="(language, i) in languageTabsNew"
                :key="language + i"
              >
                <br />
                <div class="row disablerow justify-content-between">
                  <div class="col-md-12 row disablerow">
                    <div class="col-md-8 row disablerow">
                      <div class="col-sm-12 col-md-12">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('enter_name_of_event_category') + '*'"
                          v-model="
                            eventTrainingCategory.designations[
                              language.shortForm
                            ]
                          "
                        ></v-text-field>
                      </div>
                      <div class="col-sm-12 col-md-12">
                        <v-autocomplete
                          dense
                          outlined
                          multiple
                          hide-details="auto"
                          class="datainput"
                          :items="categories"
                          item-text="text"
                          item-value="value"
                          :label="$t('category')"
                          v-model="eventTrainingCategory.category"
                        ></v-autocomplete>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('price_eur')"
                          v-model="eventTrainingCategory.price"
                        ></v-text-field>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <v-text-field
                          hide-details="auto"
                          class="datainput justify-content-end align-self-center pb-1"
                          dense
                          outlined
                          :label="$t('duration_in_days')"
                          v-model="eventTrainingCategory.durationInDays"
                        ></v-text-field>
                      </div>

                      <div class="col-sm-12 col-md-6">
                        <div class="min-number-participants">
                          <v-text-field
                            hide-details="auto"
                            class="datainput pb-1"
                            dense
                            outlined
                            :min="1"
                            type="number"
                            :label="$t('minParticipants') + '*'"
                            v-model="eventTrainingCategory.minParticipants"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div class="">
                          <v-text-field
                            hide-details="auto"
                            class="datainput pb-1"
                            dense
                            outlined
                            :min="1"
                            type="number"
                            :label="$t('maxParticipants') + '*'"
                            v-model="eventTrainingCategory.maxParticipants"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <v-autocomplete
                          dense
                          outlined
                          multiple
                          hide-details="auto"
                          class="datainput"
                          :items="selectableLocations"
                          item-text="name"
                          item-value="id"
                          :label="$t('location') + '*'"
                          v-model="eventTrainingCategory.selectedLocations"
                        ></v-autocomplete>
                      </div>

                      <div class="col-sm-12 col-md-6">
                        <v-select
                          hide-details="auto"
                          dense
                          outlined
                          class="datainput"
                          :items="types"
                          :label="$t('event_training_category_type') + '*'"
                          item-text="text"
                          item-value="value"
                          v-model="eventTrainingCategory.type"
                        ></v-select>
                      </div>
                    </div>

                    <div class="col-md-4 row disablerow">
                      <div class="col-md-12">
                        <Upload
                          v-model="eventTrainingCategory.documents"
                          multiple
                          allowOtherFileTypes
                        />
                        <div class="upload-limit-text">
                          {{ $t("max_size_1000mb") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 px-0">
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("goals") }}
                      </label>
                      <vue-editor
                        v-model="
                          eventTrainingCategory.goals[language.shortForm]
                        "
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("targetgroup") }}
                      </label>
                      <vue-editor
                        v-model="
                          eventTrainingCategory.targetGroups[language.shortForm]
                        "
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("content") }}
                      </label>
                      <vue-editor
                        v-model="
                          eventTrainingCategory.descriptions[language.shortForm]
                        "
                        :editor-toolbar="customToolbar"
                        @input="handleInput"
                      />
                    </div>
                    <div class="upload-limit-text">
                      {{ $t("characterCount") }}:
                      <span
                        :style="{
                          color:
                            characterCount > maxCharacterCount
                              ? 'red'
                              : 'inherit',
                        }"
                      >
                        {{ characterCount }}</span
                      >
                      /{{ maxCharacterCount }}
                      <div
                        v-if="characterCount > maxCharacterCount"
                        style="color: red"
                      >
                        {{ $t("characterExceeded") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 pb-4">
                    <div class="html-editor cust-html-editor mt-6">
                      <label
                        class="html-editor-headline headlinecolor formheading"
                      >
                        {{ $t("prerequesites") }}
                      </label>
                      <vue-editor
                        v-model="
                          eventTrainingCategory.prerequesites[
                            language.shortForm
                          ]
                        "
                        :editor-toolbar="customToolbar"
                      />
                    </div>
                  </div>
                </div>
              </v-tab-item>

              <div class="col-md-12 lastBtnSubmit widAuto mt-4 d-flex g-space-15">
                <v-btn
                  v-if="!editMode"
                  v-show="$rights.includes('CREATE_TRAINING_EVENT_CATEGORY')"
                  @click="saveTrainingEventCategory()"
                  outlined
                  depressed
                  tile
                  :disabled="characterCount > maxCharacterCount"
                  class="savebutton"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  v-else
                  v-show="$rights.includes('UPDATE_TRAINING_EVENT_CATEGORY')"
                  @click="saveTrainingEventCategory()"
                  outlined
                  depressed
                  tile
                  :disabled="characterCount > maxCharacterCount"
                  class="savebutton"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  @click="cancel()"
                  outlined
                  depressed
                  tile
                  class="cancelBtn"
                  >{{ $t("cancel") }}</v-btn
                >
              </div>
            </v-tabs-items>
          </div>
          <div class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row onlyContact">
            <div class="col-xl-12 right-side-block hide">
              <h4 class="text-uppercase">{{ $t("actions") }}</h4>
              <div class="right-side divider"></div>
              <div class="mt-6"></div>
              <v-btn
                @click="cancel()"
                outlined
                depressed
                tile
                class="backbutton mr-2 mb-2"
              >
                <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
              >
              <v-btn
                v-if="!editMode"
                v-show="$rights.includes('CREATE_TRAINING_EVENT_CATEGORY')"
                @click="saveTrainingEventCategory()"
                outlined
                depressed
                tile
                class="save mb-2"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                v-else
                v-show="$rights.includes('UPDATE_TRAINING_EVENT_CATEGORY')"
                @click="saveTrainingEventCategory()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                >{{ $t("save") }}</v-btn
              >
            </div>
            <Contact />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Card,
    Breadcrumb,
  },
  data() {
    return {
      selectedLocations: [],
      maxCharacterCount: 1050,
      characterCount: 0,
      editMode: false,
      languageTab: null,
      trainingEventCategoryId: null,
      eventTrainingCategoryEditName: "",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        ["clean"],
      ],

      eventTrainingCategory: {
        designations: {},
        descriptions: {},
        goals: {},
        targetGroups: {},
        prerequesites: {},
        type: null,
        qualificationNumber: null,
        category: [],
        selectedLocations: [],
        minParticipants: null,
        maxParticipants: null,
        showUpcomingSchedules: true,
        isPopular: false,
        documents: [],
      },
      activator: null,
      allCategories: [], // Full data of category list
      categories: [], // only data for select boxes
      isLoad: false,
      attach: null,
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      editingIndex: -1,
      nonce: 1,
      menu: false,
      categoryNameBreadCrumb: "",
      categoryNameBreadCrumbName: "",
      selectedCategory: null,
      x: 0,
      search: null,
      y: 0,
    };
  },

  computed: {
    languageTabsNew() {
      return this.$root.languageTabsNew;
    },
    computedCategories() {
      return this.eventTrainingCategory.category.map((cat) => ({
        value: cat.id,
        text: cat.designationMap[this.$locale.toUpperCase()],
      }));
    },
    targetGroup: {
      get() {
        return this.eventTrainingCategory &&
          this.eventTrainingCategory.targetGroups &&
          this.eventTrainingCategory.targetGroups[this.$locale.toUpperCase()]
          ? this.eventTrainingCategory.targetGroups[this.$locale.toUpperCase()]
          : "";
      },
    },
    goal: {
      get() {
        return this.eventTrainingCategory &&
          this.eventTrainingCategory.goals &&
          this.eventTrainingCategory.goals[this.$locale.toUpperCase()]
          ? this.eventTrainingCategory.goals[this.$locale.toUpperCase()]
          : "";
      },
    },
    descriptions: {
      get() {
        return this.eventTrainingCategory &&
          this.eventTrainingCategory.descriptions &&
          this.eventTrainingCategory.descriptions[this.$locale.toUpperCase()]
          ? this.eventTrainingCategory.descriptions[this.$locale.toUpperCase()]
          : "";
      },
    },
    designations: {
      get() {
        return this.eventTrainingCategory &&
          this.eventTrainingCategory.designations &&
          this.eventTrainingCategory.designations[this.$locale.toUpperCase()]
          ? this.eventTrainingCategory.designations[this.$locale.toUpperCase()]
          : "";
      },
    },
    prerequesites: {
      get() {
        return this.eventTrainingCategory &&
          this.eventTrainingCategory.prerequesites &&
          this.eventTrainingCategory.prerequesites[this.$locale.toUpperCase()]
          ? this.eventTrainingCategory.prerequesites[this.$locale.toUpperCase()]
          : "";
      },
    },
    types() {
      return [
        { value: "PRESENCE", text: this.$t("PRESENCE") },
        { value: "VIDEO", text: this.$t("VIDEO") },
        { value: "VIRTUAL", text: this.$t("VIRTUAL") },
        {
          value: "PRESENCE_AND_VIRTUAL",
          text: this.$t("PRESENCE_AND_VIRTUAL"),
        },
      ];
    },

    trainingLocationTypes() {
      return {
        CUSTOMER: { id: -1, name: this.$t("training_at_customer") },
        VIRTUAL: { id: -2, name: this.$t("virtual") },
        ACADEMY: { id: -3, name: this.$t("at_trainingacademy") },
      };
    },
    selectableLocations() {
      return [
        this.trainingLocationTypes.CUSTOMER,
        this.trainingLocationTypes.VIRTUAL,
        this.trainingLocationTypes.ACADEMY,
      ];
    },
  },
  mounted() {
    if (this.$route.query.trainingeventcategoryId) {
      this.editMode = true;
      this.trainingEventCategoryId = this.$route.query.trainingeventcategoryId;
      this.fetchTrainingEventCategory(this.trainingEventCategoryId);
    }
    this.fetchCountries();

    this.fetchCategories();

    this.selectableLocations = [];
    this.selectableLocations.push(this.trainingLocationTypes.CUSTOMER);
    this.selectableLocations.push(this.trainingLocationTypes.VIRTUAL);
    this.selectableLocations.push(this.trainingLocationTypes.ACADEMY);
    if (this.categoryName != null) {
      this.fetchSelectedCategory();
    }
  },

  methods: {
    fetchCategories() {
      var _this = this;
      this.$axios
        .get("api/category")
        .then(function (response) {
          for (let i = 0; i < response.data.length; i++) {
            const category = response.data[i];
            if (category.designationMap[_this.$locale] != null) {
              _this.categories.push({
                value: category.id,
                text: category.designationMap[_this.$locale],
              });
            }
          }
          _this.allCategories = response.data;
        })
        .catch(this.onError)
        .finally(this.onFinally);
    },
    fetchSelectedCategory() {
      var _this = this;
      this.$axios
        .get("/api/category/url", {
          params: {
            url: _this.categoryName,
          },
        })
        .then(function (response) {
          _this.training.category = {
            value: response.data.id,
            text: response.data.designationMap[_this.$locale],
          };
          _this.selectedCategory = response.data;
        })
        .catch(this.onError);
    },
    cancel() {
      this.$router.push("/training-event-category-list");
    },
    handleInput() {
      this.characterCount =
        this.eventTrainingCategory.descriptions[
          this.$locale.toUpperCase()
        ].length;
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.editingIndex = index;
      } else {
        this.editing = null;
        this.editingIndex = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },

    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    fetchCountries() {
      var _this = this;
      this.$axios
        .get("/api/location/countries")
        .then(function (response) {
          const countriesFromServer = response.data;
          _this.countries = [];
          for (let i = 0; i < countriesFromServer.length; i++) {
            const country = countriesFromServer[i];
            _this.countries.push({
              text: _this.$t(country),
              value: country,
            });
          }
          _this.countries.sort((a, b) =>
            a.text > b.text ? 1 : b.text > a.text ? -1 : 0
          );
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },

    fetchTrainingEventCategory(trainingEventCategoryId) {
      var _this = this;
      this.$axios
        .get("/api/eventTrainingCategory/" + trainingEventCategoryId)
        .then(function (response) {
          _this.eventTrainingCategory = response.data;
          for (
            let i = 0;
            i < _this.eventTrainingCategory.category.length;
            i++
          ) {
            _this.eventTrainingCategory.category[i] =
              _this.eventTrainingCategory.category[i].id;
          }
          _this.eventTrainingCategory.designations =
            _this.eventTrainingCategory.designationsMap;
          _this.lowerCaseMapKeys(_this.eventTrainingCategory.designations);
          _this.eventTrainingCategory.descriptions =
            _this.eventTrainingCategory.descriptionsMap;
          _this.lowerCaseMapKeys(_this.eventTrainingCategory.descriptions);
          _this.eventTrainingCategory.goals =
            _this.eventTrainingCategory.goalsMap;
          _this.lowerCaseMapKeys(_this.eventTrainingCategory.goals);
          _this.eventTrainingCategory.targetGroups =
            _this.eventTrainingCategory.targetGroupsMap;
          _this.lowerCaseMapKeys(_this.eventTrainingCategory.targetGroups);
          _this.eventTrainingCategory.prerequesites =
            _this.eventTrainingCategory.prerequesitesMap;
          _this.lowerCaseMapKeys(_this.eventTrainingCategory.prerequesites);

          // Preselect Training Locations and Types
          _this.eventTrainingCategory.selectedLocations = [];

          for (
            let i = 0;
            i < _this.eventTrainingCategory.locationTypes.length;
            i++
          ) {
            const locationType = _this.eventTrainingCategory.locationTypes[i];
            if (locationType == "CUSTOMER") {
              _this.eventTrainingCategory.selectedLocations.push(
                _this.trainingLocationTypes.CUSTOMER.id
              );
            }
            if (locationType == "VIRTUAL") {
              _this.eventTrainingCategory.selectedLocations.push(
                _this.trainingLocationTypes.VIRTUAL.id
              );
            }
            if (locationType == "ACADEMY") {
              _this.eventTrainingCategory.selectedLocations.push(
                _this.trainingLocationTypes.ACADEMY.id
              );
            }
          }

          for (
            let i = 0;
            i < _this.eventTrainingCategory.locations.length;
            i++
          ) {
            const location = _this.eventTrainingCategory.locations[i];
            _this.eventTrainingCategory.selectedLocations.push(location.id);
          }
          _this.categoryNameBreadCrumb =
            _this.eventTrainingCategory.designationsMap[
              _this.$locale.toUpperCase()
            ];
        })
        .catch(this.onError);
    },

    saveTrainingEventCategory() {
      var _this = this;
      var eventTrainingCategory = {};
      _this.eventTrainingCategory.category =
        _this.eventTrainingCategory.category.filter(
          (item) => typeof item === "number"
        );
      eventTrainingCategory = Object.assign(
        eventTrainingCategory,
        this.eventTrainingCategory
      );

      const languages = [
        "EN",
        "DE",
        "FR",
        "PL",
        "ES",
        "HU",
        "RU",
        "KK",
        "IT",
        "ZH",
      ];
      const allEmptyOrSpaces = languages.every(
        (lang) =>
          this.$isStringEmptyOrNull(eventTrainingCategory.designations[lang]) ||
          Object.keys(eventTrainingCategory.designations).length === 0
      );
      if (allEmptyOrSpaces) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("training_event_category") })
        );
        return;
      }

      if (!eventTrainingCategory.minParticipants) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("minParticipants") })
        );
        return;
      }

      if (!eventTrainingCategory.maxParticipants) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("maxParticipants") })
        );
        return;
      }

      if (
        Number(eventTrainingCategory.minParticipants) >
        Number(eventTrainingCategory.maxParticipants)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("maxParticipants") })
        );
        return;
      }

      //eventTrainingCategory.durationInDays
      const amountRegex = /^(\d*\.?\d+|\d{1,3}(,\d{3})*(\.\d+)?)$/;

      if (
        eventTrainingCategory.price &&
        !amountRegex.test(eventTrainingCategory.price)
      ) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("price_eur") })
        );
        return;
      }

      if (eventTrainingCategory.type == null) {
        this.$noty.error(
          this.$t("empty_value", {
            name: this.$t("event_training_category_type"),
          })
        );
        return;
      }

      this.$convertHtmlDescriptionText(eventTrainingCategory.designations);

      this.$convertHtmlDescriptionText(eventTrainingCategory.goals);
      this.$convertHtmlDescriptionText(eventTrainingCategory.targetGroups);
      this.$convertHtmlDescriptionText(eventTrainingCategory.descriptions);
      this.$convertHtmlDescriptionText(eventTrainingCategory.prerequesites);
      eventTrainingCategory.locationTypes = "";
      eventTrainingCategory.locations = "";
      for (let i = 0; i < eventTrainingCategory.selectedLocations.length; i++) {
        var selectedLocation = eventTrainingCategory.selectedLocations[i]; // id
        if (selectedLocation <= 0) {
          if (selectedLocation == this.trainingLocationTypes.CUSTOMER.id) {
            selectedLocation = "CUSTOMER";
          }
          if (selectedLocation == this.trainingLocationTypes.VIRTUAL.id) {
            selectedLocation = "VIRTUAL";
          }
          if (selectedLocation == this.trainingLocationTypes.ACADEMY.id) {
            selectedLocation = "ACADEMY";
          }
          eventTrainingCategory.locationTypes += ";" + selectedLocation;
        } else {
          eventTrainingCategory.locations += ";" + selectedLocation;
        }
      }
      if (eventTrainingCategory.locationTypes.startsWith(";")) {
        eventTrainingCategory.locationTypes =
          eventTrainingCategory.locationTypes.substring(1);
      }
      if (eventTrainingCategory.locations.startsWith(";")) {
        eventTrainingCategory.locations =
          eventTrainingCategory.locations.substring(1);
      }

      if (!eventTrainingCategory.locationTypes) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("location") }));
        return;
      }

      console.log(eventTrainingCategory.locationTypes);
      if (this.trainingEventCategoryId === null) {
        this.$axios
          .post("/api/eventTrainingCategory", eventTrainingCategory)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("training_event_category_saved", {
                name: response.data.designationUrl,
              })
            );
            _this.$router.push("/training-event-category-list");
          })
          .catch(this.onError);
      } else {
        this.$axios
          .put(
            "/api/eventTrainingCategory/" + this.trainingEventCategoryId,
            eventTrainingCategory
          )
          .then(function (response) {
            _this.$noty.success(_this.$t("training_event_category_edited"));
            _this.$router.push("/training-event-category-list");
          })
          .catch(this.onError);
      }
    },
  },
};
</script>
